import './liveTrackVehicles.css';
import {useState} from "react";
const LiveTrackVehicles = () => {
    const [selectedVehicle, setSelectedVehicle] = useState(2);
    const handleSelectTrip = (index) => {
        setSelectedVehicle(index);
    }

    return(
        <ul className={'liveTrack-vehicle-list font-14'}>
            {[1, 2, 3, 4, 5, 6, 7].map((trip) =>
                <li key={trip} className={trip === selectedVehicle ? 'selected' : ''}
                    onClick={e => handleSelectTrip(trip)}>
                    <ul className="separator gap-10  sf-medium margin-b-5">
                        <li className={'to sf-bold font-15'}>KA 02  N 9023</li>
                        <li>Avg Speed: <span className={'blue-color'}>19 Km/h</span></li>
                    </ul>
                    <div className="trip-details">
                        <ul className="separator gap-20 margin-b-5">
                            <li>Vehicle Type: HMV</li>
                            <li>Model: Eicher</li>
                        </ul>
                        <div className="font-12 grey-color">Last Updated : 6 Dec, 07:30 AM</div>
                    </div>
                </li>
            )}
        </ul>
    )
}

export default LiveTrackVehicles;
